import React, { FC } from 'react';
import { assignInlineVars } from '@fiverr-private/theme';
import { AspectRatio, Container } from '@fiverr-private/layout_components';
import { Link } from '@fiverr-private/typography';
import {
  arClassName,
  hThumbnailClassName,
  hThumbnailLastClassName,
  indexVar,
  vThumbnailClassName,
} from './Thumbnail.css';

export type Variant = 'vertical' | 'horizontal';

export interface ThumbnailProps {
  isActive?: boolean;
  href?: string;
  label?: string;
  index?: number;
  variant?: Variant;
  isLast?: boolean;
  onClick?: () => void;
}

export const Thumbnail: FC<ThumbnailProps> = ({
  label,
  isActive,
  onClick,
  href,
  index = 0,
  variant = 'vertical',
  children,
  isLast,
}) => {
  const isClickable = !!href || typeof onClick === 'function';
  const handleClick = isClickable ? onClick : undefined;

  const Component = (() => {
    if (isClickable) {
      return href ? Link : 'button';
    }

    return Container;
  })();

  const getClassName = () => {
    if (variant === 'horizontal') {
      return isLast ? hThumbnailLastClassName : hThumbnailClassName;
    }

    return vThumbnailClassName;
  };

  return (
    <Component
      aria-label={label}
      onClick={handleClick}
      href={href}
      className={getClassName()}
      style={assignInlineVars({ [indexVar]: (index + 1).toString() })}
    >
      <AspectRatio
        className={arClassName}
        ratio="1.33/1"
        borderColor={isActive ? 'black' : 'border'}
        borderRadius={isActive ? 'sm' : 'md'}
        borderWidth={isActive ? 'md' : 'sm'}
        padding={isActive ? '0.5' : undefined}
      >
        {children}
      </AspectRatio>
    </Component>
  );
};
